import { SET_ERROR_MESSAGE, SET_ERROR_MESSAGE_MODAL } from "../constants";

const initialState = {
  errors: null,
  errorModalVisible: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ERROR_MESSAGE:
      return { ...state, errors: payload };

    case SET_ERROR_MESSAGE_MODAL:
      return { ...state, errorModalVisible: payload };
      
    default:
      return state;
  }
};
